// extracted by mini-css-extract-plugin
export default {"centerPanel":"TopCenterControls_centerPanel__ACSaW","switcher":"TopCenterControls_switcher__neWaA"};